import { OldDesktopMenu } from "../old-menu/old-desktop-menu";
import { OldMobileMenu } from "../old-menu/old-mobile-menu";
import { OldMainMenu } from "../old-menu/types";

export const DesktopMenu = ({
  globalStoryblokStories,
  bgColor,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  globalStoryblokStories?: any[];
  bgColor?: string;
}) => {
  const data = globalStoryblokStories?.find(
    (story) =>
      story.lookupConfiguration?.slug === "shared-content/menus/old-main-menu",
  )?.content?.[0] as OldMainMenu;

  return (
    <>
      <OldDesktopMenu data={data} bgColor={bgColor ?? "white"} />
      <OldMobileMenu data={data} />
    </>
  );
};
